import React from 'react';
import { EMPTY_COUNT, SHORT_TRUE, NO_RECORDS_FOUND, EMPTY_STRING, HALF_HYPHEN, FIRST_INDEX } from '../../../utils/constants';
import WarningAlert from '../../components/WarningAlert';
import { WARNING_SHIPPING_INPUT } from '../../../utils/messages';
import { isNullOrEmpty, formatCurrency } from '../../../utils/common';
import { isNullOrUndefined } from 'util';

const OrderListTable = (props) => {

    const smallHeaderStyle = "custom-order-header order-row-small";
    const fullHeaderStyle = "custom-order-header full-width";
    const smallRowStyle = "custom-order-row order-row-small row-selection";
    const fullRowStyle = "custom-order-row full-width row-selection";
    const fullFlex = "flex full-width";

    const RenderRows = (
        props.list.map((row, index) => {
            let isDefaultValue = isNullOrUndefined(row.orderedProducts);
            let orderedProducts = HALF_HYPHEN !== props.predictions[index] && isDefaultValue && SHORT_TRUE === row.displayForecast ? props.predictions[index] : row.orderedProducts;
            
            return (
                <div key={index} id="sample" className={[fullFlex, " bottom-border-gray"]} onClick={props.viewMonthlyOrders.bind(this, row)}>
                    <div className={[fullRowStyle]}>
                        <div className="mobile-name-price">{row.productName1}</div>
                        <div className="mobile-name-price">
                            {row.productName2}
                            <span className="price-row">{(SHORT_TRUE === row.displayPrice && !isNullOrEmpty(row.strProposalPrice)) && `${ formatCurrency(row.proposalPrice)}円`}</span>
                        </div>
                    </div>
                    <div className={smallRowStyle}>
                        {props.disableInput
                            ? (
                                <p className={(row.hasOrder ? (row.isPlainBG ? "mobile-number-p-disabled-bg-plain text-red " : "mobile-number-p-disabled-bg-yellow text-red ") : "mobile-number-p-disabled-bg-plain ")} >{row.dbOrdered}</p>
                            ) : (
                                <input
                                    id={index.toString()}
                                    type="number"
                                    className={row.hasOrder ? row.isPlainBG ? "mobile-number-input text-red" : "mobile-number-input text-red bg-yellow" : "mobile-number-input"}
                                    onChange={props.handleInputChange}
                                    onFocus={()=>{
                                            if(isDefaultValue || EMPTY_COUNT === orderedProducts){
                                                document.getElementById(`${index.toString()}`).value = undefined;
                                            }else{
                                                document.getElementById(`${index.toString()}`).value = orderedProducts;
                                            }
                                    }}
                                    onBlur={()=>{
                                        if(isDefaultValue){
                                            document.getElementById(`${index.toString()}`).value = undefined;
                                        }else{
                                            document.getElementById(`${index.toString()}`).value = orderedProducts;
                                        }
                                    }}
                                    value={(EMPTY_STRING === orderedProducts || isNullOrUndefined(orderedProducts)) ? EMPTY_STRING : orderedProducts}
                                    pattern="\d+"
                                />
                            )}
                    </div>

                    {SHORT_TRUE === row.displayForecast ? <div className={smallRowStyle}>{row.prediction}</div> : ""}
                </div>
            )
        })
    )

    return (
        <div>
            <div className={fullFlex}>
                
            <WarningAlert className={fullFlex} warning={props.list.length > EMPTY_COUNT && props.list[FIRST_INDEX].isShipping === SHORT_TRUE ? [WARNING_SHIPPING_INPUT] : []}/>
            </div>

            <div className={fullFlex}>
                <div className={fullHeaderStyle}></div>
                <div className={smallHeaderStyle}>発注数</div>
                {props.list[FIRST_INDEX] && (SHORT_TRUE === props.list[FIRST_INDEX].displayForecast) ? <div className={smallHeaderStyle}>(予測数)</div>: ""}
            </div>

            {props.list && (EMPTY_COUNT < props.list.length) ? RenderRows : NO_RECORDS_FOUND}
        </div>
    )
}

export default OrderListTable;